export default function ExampleForm() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-foreground">Example Form</h1>
      <p className="text-muted-foreground mt-1">Form example placeholder</p>
    </div>
  )
}
